import React from 'react';
import { Button, ButtonToolbar } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

const ActionButtons = ({
  buttonComponent: ButtonComponent,
  containerComponent: ContainerComponent,
  containerId,
  onDeleteEventClick,
  onEditEventClick,
  onOpenClick,  
  showLabels,
  showApptMenuItem,
  ...props
}) => {
  
  
  
  return (
  <ContainerComponent id={containerId} {...props}>
    {typeof onOpenClick === 'function' && showApptMenuItem && (
      <ButtonComponent onClick={onOpenClick}>
        <FontAwesome name="external-link" />
        {showLabels && " Open"}
      </ButtonComponent>
    )}
   
    {typeof onEditEventClick === 'function' && (
      <ButtonComponent onClick={onEditEventClick}>
        <FontAwesome name="pencil" />
        {showLabels && " Edit"}
      </ButtonComponent>
    )}
    {typeof onDeleteEventClick === 'function' && (
      <ButtonComponent onClick={onDeleteEventClick}>
        <FontAwesome name="trash-o" />
        {showLabels && " Delete"}
      </ButtonComponent>
    )}
  </ContainerComponent>
);}

ActionButtons.defaultProps = {
  buttonComponent: Button,
  containerComponent: ButtonToolbar,
  showLabels: false
};

export default ActionButtons;
